import {DataObjectId} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {Board} from '@extensions/board'
import {globals} from '@extensions/globals-base'
import {CbProps} from './types'

export const getColumns = (boardId?: DataObjectId): CbProps[] => {
  if (!boardId) {
    return []
  }

  const box = Sync.getCurrentSandbox()
  const board = box.get(boardId)
  const companyId = globals.getCompanyId()
  const hierarchy = DepartmentsClient.getHierarchy(Sync.get({companyId}))

  const columns = Board.listColumns(board, {
    hierarchy,
    noMirrors: true,
    sorted: true
  })

  return columns
}
